import { showHttpError } from '@calendly/alert'
import { buildQuery, httpRequest, parseQuery } from '@calendly/http-tools'

import { redirectTo } from 'actions/core/navigation'

export const redirectToAuthorizeUrl = (path) => (
  async (dispatch) => {
    const [success, data] = await httpRequest({
      method: 'POST',
      url: path
    })

    if (success) {
      dispatch(redirectTo(data.url))
      return
    }

    if (data.payload?.type === 'invalid_csrf') {
      const query = parseQuery(window.location.search)
      query.error = 'invalid_csrf'
      const search = buildQuery(query, { addQueryPrefix: true })
      window.location.search = search
    } else {
      dispatch(showHttpError(data))
    }
  }
)
